import { Pipe, PipeTransform } from '@angular/core';
import { INavItem } from '../models/nav-item.model';

@Pipe({
  name: 'isNavItemActive',
  standalone: true,
})
export class IsNavItemActivePipe implements PipeTransform {
  transform(currentUrl: string | null, item: INavItem): boolean {
    return currentUrl?.includes(item.url) ?? false;
  }
}
